import { lazy } from 'react';

// project imports
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';
import AuthGuard from 'utils/route-guard/AuthGuard';
import SuspenseLoader from 'CommonUiComponents/loaders/suspenseLoader';

// dashboard routing
const DashboardDefault = Loadable(lazy(() => import('views/dashboard/Default')));

// member list page routing
const MemberListPage = Loadable(lazy(() => import('views/pages/member-list')));

// member details page routing
const MemberDetailsPage = Loadable(lazy(() => import('views/pages/member-details')));

// recharge history page routing
const RechargeHistory = Loadable(lazy(() => import('views/pages/member-details/rechargeHistory')));

// MemberPriorityPage routing
const MemberPriorityPage = Loadable(lazy(() => import('views/pages/member-priority')));

// OCTicketsPage routing
const OCTicketsPage = Loadable(lazy(() => import('views/pages/open-close-tickets')));

// member booking page routing
const BookingListPage = Loadable(lazy(() => import('views/pages/booking-list')));

// member booking page routing
const RequirementFunnelPage = Loadable(lazy(() => import('views/pages/requirement-funnel')));

// create quote page routing
const CreateQuotePage = Loadable(lazy(() => import('views/pages/create-quote')));

// quote preview page routing
const FullQuotePreview = Loadable(lazy(() => import('views/pages/create-quote/fullQuotePreview')));

// booking request page routing
const BookingRequestPage = Loadable(lazy(() => import('views/pages/booking-requests')));

// booking detail page routing
const BookingDetailPage = Loadable(lazy(() => import('views/pages/booking-details')));

const NewBookingDetailPage = lazy(() => import('views/pages/newBookingDetails/bookingDetailMaster'));

// internal commenting page routing
const InternalCommentingPage = Loadable(lazy(() => import('views/pages/internal-commenting')));

// create pending booking page routing
const CreatePendingBookingPage = Loadable(lazy(() => import('views/pages/pending-booking')));

// create booking list page for package bookings
const PackageBookings = Loadable(lazy(() => import('views/pages/package-bookings')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <MainLayout />
        </AuthGuard>
    ),
    children: [
        {
            path: '/dashboard/default',
            element: <DashboardDefault />
        },
        {
            path: '/member-list',
            element: <MemberListPage />
        },
        {
            path: '/member-list/:code',
            element: <MemberListPage />
        },
        {
            path: '/member-list/member-details/:id',
            element: <MemberDetailsPage />
        },
        {
            path: '/member-list/member-details/:id/recharge-history/:orgCode',
            element: <RechargeHistory />
        },
        {
            path: '/booking-list',
            element: <BookingListPage />
        },
        {
            path: '/booking-list/:bookingCode',
            element: (
                <SuspenseLoader>
                    <NewBookingDetailPage />
                </SuspenseLoader>
            )
        },
        {
            path: 'open-close-tickets/:id',
            element: <OCTicketsPage />
        },
        {
            path: '/open-close-tickets',
            element: <OCTicketsPage />
        },
        {
            path: '/requirement-funnel',
            element: <RequirementFunnelPage />
        },
        {
            path: '/requirement-funnel/:id',
            element: <RequirementFunnelPage />
        },
        {
            path: '/member-priority',
            element: <MemberPriorityPage />
        },
        {
            path: '/member-priority/:code',
            element: <MemberPriorityPage />
        },
        {
            path: '/create-quote',
            element: <CreateQuotePage />
        },
        {
            path: '/create-quote/:id',
            element: <CreateQuotePage />
        },
        {
            path: '/quote-preview/:id',
            element: <FullQuotePreview />
        },
        {
            path: '/booking-requests',
            element: <BookingRequestPage />
        },
        {
            path: '/internal-commenting',
            element: <InternalCommentingPage />
        },
        {
            path: '/internal-commenting/:code',
            element: <InternalCommentingPage />
        },
        {
            path: '/create-pending-booking',
            element: <CreatePendingBookingPage />
        },
        {
            path: '/package-bookings',
            element: <PackageBookings />
        }
    ]
};

export default MainRoutes;
